export default class CanvasChangeHistory {
    /**
     * Creates a temporary history of changes within a component for perusal
     * @module CanvasChangeHistory
     */
    constructor(changeObject){
        this.changeHistory = [];
        this.changeIndex = 0;
        this.init();
    }

    getChangeTypes(){
        return {
            CLONE: "clone",
            DELETE: "delete",
            MOVED_POINT_POSITION: "movedPointPosition",
            MOVED_POSITION: "movedPosition",
            NEW_LINK_POINT: "newLinkPoint",
            NEW_LINK_SOURCE: "newLinkSource",
            NEW_LINK_TARGET: "newLinkTarget",
            REQUEST_CLONE: "request-clone",
            REQUEST_CREATE_NODE_AT_EVENT: "request-create-node-at-event",
            REQUEST_DUPLICATE: "request-duplicate",
            REQUEST_INSERT: "request-insert",
            REMOVE_LINK_POINT: "removeLinkPoint",
            REQUEST_PASTE: "request-paste",
            REQUEST_REPLACE: "request-replace",
            REQUEST_UPDATE_MEMBER: "request-update-member"
        }
    }

    init() {
        const changeObject = this.getChangeObject("init");
        this.changeHistory.push(changeObject);
    }

    getChangeObject(type){
        return {
            type: type || 'unknown',
            nodes: [],
            links: [],
            models: [],
            index: '',
            point: {},
            linkView: {},
            previousTimestamp: '',
            preserved: false
        };
    }

    saveChanges(type, changes = null){
        const changeObject = this.getChangeObject(type);
        
        if(changes){
            Object.entries(changes).forEach(([key, value]) => {
				if (key === "nodes") {
					changeObject.nodes.push(...value);
				}
				if (key === "links") {
                    changeObject.links.push(...value);
				}
				if (key === "models") {
                    changeObject.models.push(...value);
				}
				if (key === "index") {
                    changeObject.index = value;
				}
				if (key === "point") {
                    changeObject.point = value;
				}
				if (key === "linkView") {
                    changeObject.linkView = value;
				}
                if (key === "previousTimestamp") {
                    changeObject.previousTimestamp = value;
				}
			});
        }

        if(this.changeIndex + 1 === this.changeHistory.length) {
            this.changeHistory.push(changeObject);
            // only 20 change objects tracked at a time
            if(this.changeHistory.length === 21) {
                this.changeHistory.shift();
            } else {
                this.changeIndex++;
            }
        } else {
            // this section preserves changes made when adding a new change while a previous change has been selected
            // these items are all changeObjects that exist after the current index before we add the new event
            const preservedChangePath = this.changeHistory.slice(this.changeIndex + 1,this.changeHistory.length).reverse();
            const newPath = [];
            // flag reindexed items for reverse path actions when drawing history
            preservedChangePath.forEach(object => {
                const newObject = {
                    nodes: object.nodes,
                    links: object.links,
                    models: object.models,
                    index: object.index,
                    point: object.point,
                    linkView: object.linkView,
                    type: object.type,
                    previousTimestamp: object.previousTimestamp
        
                };

                newObject.preserved = !newObject.preserved;

                newPath.push(newObject);

            });

            // add reindexed items back to the change history
            this.changeHistory = this.changeHistory.concat(newPath);

            // finally, add the new event where it belongs at the end
            this.changeHistory.push(changeObject);

            //history length cannot be longer than 20 objects. earlier objects removed first
            if(this.changeHistory.length > 20) {
                this.changeHistory.slice(-20);
            }

            // index is now the last index because of new event
            this.changeIndex = this.changeHistory.length - 1;
        }

    }

    selectCurrentIndex() {
        if(this.changeIndex === 0){
            return;
        }
        return this.changeHistory[this.changeIndex];
    }
    
    selectNextIndex(){
        // change objects do not exist outside of total array length
        if(this.changeIndex + 1 === this.changeHistory.length || this.changeHistory.length === 1){
            return;
        }
        this.changeIndexIncrement();
        return this.changeHistory[this.changeIndex];
    }

    selectPreviousIndex(){
        // change objects do not exist below index 0
        if(this.changeIndex === 0){
            return;
        }
        this.changeIndexDecrement();
        return this.changeHistory[this.changeIndex];
    }
    changeIndexDecrement() {
        this.changeIndex--;
    }
    changeIndexIncrement() {
        this.changeIndex++;
    }
}
